import { useTheme } from "../theme"

export const ErrorFill = () => {
  const theme = useTheme()
  const fill = theme.palette.full.orange
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1764_10827)">
        <path
          d="M40.499 20.0005C40.499 31.0521 31.5511 40 20.4995 40C9.44793 40 0.5 31.0521 0.5 20.0005C0.5 8.94891 9.44793 0.000976562 20.4995 0.000976562C31.5511 0.000976562 40.499 8.94891 40.499 20.0005Z"
          fill={fill}
        />
        <path
          d="M19.75 16.76C19.75 16.3458 20.0858 16.01 20.5 16.01C20.9142 16.01 21.25 16.3458 21.25 16.76L19.75 16.76ZM21.25 19.76C21.25 20.1742 20.9142 20.51 20.5 20.51C20.0858 20.51 19.75 20.1742 19.75 19.76L21.25 19.76ZM20.5 23.51C20.0858 23.51 19.75 23.1742 19.75 22.76C19.75 22.3458 20.0858 22.01 20.5 22.01L20.5 23.51ZM20.5075 22.01C20.9217 22.01 21.2575 22.3458 21.2575 22.76C21.2575 23.1742 20.9217 23.51 20.5075 23.51L20.5075 22.01ZM27.25 19.76C27.25 16.0321 24.2279 13.01 20.5 13.01L20.5 11.51C25.0563 11.51 28.75 15.2037 28.75 19.76L27.25 19.76ZM20.5 13.01C16.7721 13.01 13.75 16.0321 13.75 19.76L12.25 19.76C12.25 15.2037 15.9436 11.51 20.5 11.51L20.5 13.01ZM13.75 19.76C13.75 23.4879 16.7721 26.51 20.5 26.51L20.5 28.01C15.9437 28.01 12.25 24.3164 12.25 19.76L13.75 19.76ZM20.5 26.51C24.2279 26.51 27.25 23.4879 27.25 19.76L28.75 19.76C28.75 24.3164 25.0563 28.01 20.5 28.01L20.5 26.51ZM21.25 16.76L21.25 19.76L19.75 19.76L19.75 16.76L21.25 16.76ZM20.5 22.01L20.5075 22.01L20.5075 23.51L20.5 23.51L20.5 22.01Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1764_10827">
          <rect width="39.999" height="39.999" fill="white" transform="translate(0.5 0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  )
}
